(function () {
  'use strict';

  var boxen = document.querySelectorAll('[data-fck-arb]');
  if (!boxen.length) return;

  var MONITOR_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<rect x="3" y="4" width="18" height="12" rx="2"></rect>'
    + '<path d="M9 20h6M12 16v4"></path></svg>';
  var TISCH_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M3 9h18M6 9v10M18 9v10"></path></svg>';

  var daten = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function proxy() { return (window.FinderClean && window.FinderClean.proxy) || '/apps/monitor-db'; }
  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }
  function zahl(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }
  function bildAdresse(u) {
    if (typeof u !== 'string' || !u) return '';
    return u.indexOf('/media/') === 0 ? proxy() + u : u;
  }
  function auswahl() {
    try { return JSON.parse(localStorage.getItem('3idee_auswahl') || 'null') || {}; }
    catch (e) { return {}; }
  }
  function holen(ref) {
    if (daten[ref]) return Promise.resolve(daten[ref]);
    return abruf(proxy() + '/monitors/' + encodeURIComponent(ref)).then(function (json) {
      var d = (json && json.ok && json.data) || {};
      daten[ref] = { bild: bildAdresse(d.image_url),
                     unten: [d.size_inch ? zahl(d.size_inch) + '"' : '', d.weight_g ? zahl(d.weight_g / 1000) + ' kg' : '']
                       .filter(Boolean).join(' · '),
                     vesa: d.vesa || null };
      return daten[ref];
    }).catch(function () { daten[ref] = { bild: '', unten: '', vesa: null }; return daten[ref]; });
  }

  function vesaChip(ref, box) {
    var v = (daten[ref] || {}).vesa;
    if (!v) return '';
    if (v.mount === 'NO') return '<span class="fn-vesa-chip is-static is-none"><span>'
      + esc(box.getAttribute('data-fck-arb-wort-novesa') || 'Kein VESA') + '</span></span>';
    if (v.patterns && v.patterns.length) return '<span class="fn-vesa-chip is-static is-ok"><span>'
      + esc('VESA ' + v.patterns[0]) + '</span></span>';
    return '';
  }

  function zeichnen(box) {
    var a = auswahl();
    var refs = (a.refs || []).map(String), namen = a.namen || [];
    var t = a.tisch || null;
    var liste = box.querySelector('[data-fck-arb-liste]');
    var knopf = box.querySelector('[data-fck-arb-knopf]');
    var tn = {};
    try { tn = JSON.parse(box.getAttribute('data-fck-arb-tisch-namen') || '{}'); } catch (e) {}

    var zaehler = {}, reihe = [];
    refs.forEach(function (ref, i) {
      if (zaehler[ref] == null) { zaehler[ref] = 0; reihe.push({ ref: ref, name: namen[i] || (i === 0 ? a.name : '') || ref }); }
      zaehler[ref]++;
    });
    var zeilen = reihe.map(function (m) {
      var d = daten[m.ref] || {};
      var n = zaehler[m.ref];
      return '<div class="fck__arb-zeile">'
        + '<span class="fck__arb-bild">' + (d.bild ? '<img src="' + esc(d.bild) + '" alt="" loading="lazy">' : MONITOR_SVG) + '</span>'
        + '<span class="fck__arb-txt"><b>' + (n > 1 ? n + '× ' : '') + esc(m.name) + '</b>'
        + ((d.unten || d.vesa) ? '<span class="fck__arb-daten">' + esc(d.unten || '') + vesaChip(m.ref, box) + '</span>' : '')
        + '</span></div>';
    });
    if (reihe.length) {
      var wort = box.getAttribute(refs.length > 1 ? 'data-fck-arb-wort-deine-monitore' : 'data-fck-arb-wort-dein-monitor') || '';
      if (wort) zeilen.unshift('<p class="fck__arb-titel">' + esc(wort) + '</p>');
    }
    if (t && (t.gruppe || t.dicke_cm) && !box.hasAttribute('data-fck-arb-ohne-tisch')) {
      var was = [tn[t.gruppe] || '', t.dicke_cm ? zahl(t.dicke_cm) + ' cm' : ''].filter(Boolean).join(' · ');
      zeilen.push('<div class="fck__arb-zeile"><span class="fck__arb-bild">' + TISCH_SVG + '</span>'
        + '<span class="fck__arb-txt"><b>' + esc(box.getAttribute('data-fck-arb-wort-tisch') || 'Tischplatte') + '</b>'
        + '<span>' + esc(was) + '</span></span></div>');
    }
    var kopf = box.querySelector('.fck__falt-wort');
    if (kopf) kopf.hidden = zeilen.length > 0;
    box.classList.toggle('fck__arb--gewaehlt', zeilen.length > 0);
    liste.innerHTML = zeilen.join('');
    liste.hidden = !zeilen.length;
    if (knopf) knopf.textContent = zeilen.length
      ? (box.getAttribute('data-fck-arb-wort-aendern') || 'Ändern')
      : (box.getAttribute('data-fck-arb-wort-angeben') || 'Monitor angeben');

    var offen = refs.filter(function (r) { return !daten[r]; });
    if (offen.length) Promise.all(offen.map(holen)).then(function () { zeichnen(box); });
  }

  function alle() { boxen.forEach(zeichnen); }
  alle();
  document.addEventListener('finder:auswahl', alle);
})();
